import { Button, CircularProgress } from "@mui/material";
import {useCurrentHeight, useHeightRestrictionActions, useHeightRestrictionIsLoading, useHeightRestrictions} from "../../../stores/MapLayers/HeightRestrictionStore"
import {getHeightRestrictions} from "../../../services/OgcService/HeightRestrictionService"
import { HeightRestrictionIcon } from "../../../assets/heightRestrictionIcon";
import React, { useEffect, useState } from 'react'

export interface IHeightRestrictionsMapLayerProps {
}


export function HeightRestrictionsMapLayer(props: IHeightRestrictionsMapLayerProps){
    const [] = useState(false);
    const [className, setClassName] = useState('mapLayerContainerInactive');

    const heightRestrictions = useHeightRestrictions();
    const isLoading = useHeightRestrictionIsLoading();
    const currentHeight = useCurrentHeight();
    const {setHeightRestrictions, setIsLoading} = useHeightRestrictionActions();

    async function handleClick(){
        if(heightRestrictions == null){
            setIsLoading(true);
            setHeightRestrictions(await getHeightRestrictions(currentHeight))
            setIsLoading(false)
        }
        else{
            setHeightRestrictions(null);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if(heightRestrictions !== null){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [heightRestrictions])

    return(
        <div style={{display: 'grid', marginLeft: '20px', maxHeight: '90%'}}>
        <div className={className} onClick={handleClick}>
            {isLoading && 
                <div className="loadingSpinner">
                <CircularProgress style={{textAlign : 'center', marginTop: '15%'}}/>
             </div>
            }
            <HeightRestrictionIcon meter={currentHeight}/>
        </div>
        <p style={{fontSize: '14px', margin: 'auto', fontWeight: 'bold'}}>Høydebegrensninger</p>
        </div>
        )
}